import React from 'react';
import DemoBookingModal from './DemoBookingModal';
import EliteBuyerModal from './EliteBuyerModal';
import EventModal from './EventModal';

const ModalsContainer = () => {
  // Always render modals, they will be controlled by the functions.js
  return (
    <>
      <DemoBookingModal />
      <EliteBuyerModal />
      <EventModal />
    </>
  );
};

export default ModalsContainer;

